<template>
  <div>
    <transaction-tabs type="imprest"></transaction-tabs>
    <m-form
      :title="title"
      :formName="title"
      exportBaseUrl="imprests/imprestSettlement/all"
      :exportParams="{ id: item.id }"
      :showList="false"
      :can-delete="item.id != null"
      :isEditing.sync="isEditing"
      :showListBtn="false"
      @goToForm="getItemByPosition"
      @submit="submit"
      @delete="deleteItem"
      @clearForm="clearForm"
    >
      <template #header-btns>
        <open-sanad-btn v-if="item.sanad" :sanad="item.sanad" />

        <v-btn
          depressed
          v-if="imprest.id != undefined"
          class="secondary white--text mr-1 mt-1 mt-md-0 rounded-lg"
          :to="{ name: 'TransactionForm', params: { id: imprest.id, type: 'imprest' } }"
          >مشاهده پرداخت</v-btn
        >
      </template>

      <template>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="1">
                <div id="imprest-settlement-code">
                  <v-text-field class="rounded-lg" label="شماره" :value="item.code" disabled />
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div id="imprest-settlement-date">
                  <date v-model="item.date" label=" * تاریخ " :default="true"
                        :disabled="!isEditing" ref="date" />
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div id="imprest-settlement-account">
                  <account-select
                    label="نام تنخواه گردان * "
                    :items-type="accountUsage.IMPREST"
                    v-model="item.account"
                    :floatAccount1.sync="item.floatAccount1"
                    :floatAccount2.sync="item.floatAccount2"
                    :floatAccount3.sync="item.floatAccount3"
                    :floatAccount4.sync="item.floatAccount4"
                    :disabled="!isEditing"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="2" v-if="settleableAmount == null">
                <template>
                    <v-btn
                        @click="getSettleableAmount()"
                        id="imprest-settlement-get-amount-btn"
                        class="rounded-lg primary white--text mt-1"
                        depressed :disabled="!item.account">
                      مشاهده مبلغ قابل تسویه
                    </v-btn>
                </template>
              </v-col>
              <v-col cols="12" md="2" v-else>
                <money label="مبلغ قابل تسویه" :disabled="true" :value="settleableAmount" />
              </v-col>
              <v-col cols="12" md="5">
                <div  id="imprest-settlement-explanation">
                  <v-textarea  label="توضیحات" v-model="item.explanation" :disabled="!isEditing" class="rounded-lg">
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <input-table class="form-items" v-model="rows">
              <template #thead>
                <tr>
                  <th class="tableHeader secondary--text">#</th>
                  <th class="tableHeader secondary--text">* تاریخ</th>
                  <th class="tableHeader secondary--text">شرح تنخواه</th>
                  <th class="tableHeader secondary--text">* نام حساب</th>
                  <th class="tableHeader secondary--text">مبلغ خرید و هزینه</th>
                  <th class="tableHeader secondary--text">مالیات ارزش افزوده</th>
                  <th class="tableHeader secondary--text">جمع کل فاکتور و ارزش افزوده</th>
                  <th class="tableHeader secondary--text">کارمزد بانکی</th>
                  <th class="tableHeader secondary--text" colspan="1">پیوست</th>
                  <th class="tableHeader" style="width: 32px">
                    <v-icon color="secondary" x-small>fa-trash</v-icon>
                  </th>

                </tr>
              </template>
              <template #tbody>
                <tr v-for="(row, i) in rows" :key="i"
                    :class="{ 'd-print-none': i == rows.length - 1, draggable: i != rows.length - 1 && isEditing }"
                >
                  <td class="tr-counter">{{ i + 1 }}</td>
                  <td style="width: 100px" id="imprest-settlement-row-date">
                    <date v-model="rows[i].date" :disabled="!isEditing" />
                  </td>
                  <td class="tr-textarea"  id="imprest-settlement-row-explanation">
                    <row-textarea
                      v-model="rows[i].explanation"
                      :disabled="!isEditing"
                      :i="i"
                      @updateRowsExplanation="updateRowsExplanation"
                    />
                  </td>
                  <td class="tr-account" v-tooltip="accountParentsName(row.account).join(' > ')"
                      id="imprest-settlement-row-account">
                    <account-select
                      :horizontal="true"
                      items-type="level3"
                      v-model="rows[i].account"
                      :disabled="!isEditing"
                      :floatAccount1.sync="row.floatAccount1"
                      :floatAccount2.sync="row.floatAccount2"
                      :floatAccount3.sync="row.floatAccount3"
                      :floatAccount4.sync="row.floatAccount4"
                    />
                  </td>
                  <td style="width: 120px" id="imprest-settlement-row-amount">
                    <money :disabled="!isEditing" v-model="rows[i].value" />
                  </td>
                  <td style="width: 100px" id="imprest-settlement-row-value-add-tax">
                    <money :disabled="!isEditing" v-model="rows[i].tax" />
                  </td>
                  <td style="width: 120px" id="imprest-settlement-row-sum">
                    <money :disabled="true" :value="rowFactorSum(row)" />
                  </td>
                  <td style="width: 100px"  id="imprest-settlement-row-bank-amount">
                    <money :disabled="!isEditing" v-model="rows[i].wage" />
                  </td>
                  <td style="max-width: 80px" id="imprest-settlement-row-file">
                    <m-file-input
                      :disabled="!isEditing"
                      v-model="rows[i].attachment"
                      :delete-attachment.sync="rows[i].delete_attachment"
                    />
                  </td>
                  <td class="d-print-none"  id="imprest-settlement-row-delete">
                    <v-btn
                      @click="deleteRow(i)"
                      class="red--text"
                      icon
                      :disabled="!isEditing || (i == rows.length - 1)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr class="back">
                  <td colspan="3"></td>
                  <td class="text-left">مجموع:</td>
                  <td class>{{ rowsSum("value") | toMoney }}</td>
                  <td class>{{ rowsSum("tax") | toMoney }}</td>
                  <td class>{{ (+rowsSum("tax") + +rowsSum("value")) | toMoney }}</td>
                  <td class>{{ rowsSum("wage") | toMoney }}</td>
                  <td></td>
                  <td class="d-print-none">
                    <v-btn id="imprest-settlement-delete-all-row"
                        @click="deleteRow(-1)" icon class="red--text" :disabled="!isEditing">
                      <v-icon>delete_sweep</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr class="grey lighten-3 text-white" v-if="settleableAmount != null">
                  <td colspan="3"></td>
                  <td colspan="2"></td>
                  <td class="text-left">اختلاف:</td>
                  <td dir="ltr">{{ (settleableAmount - rowsSum("value")) | toMoney }}</td>
                  <td colspan="3"></td>
                </tr>
              </template>
            </input-table>
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";
import { MFormMixin } from "@/components/m-form";

export default {
  name: "Form",
  components: { money, date, TransactionTabs },
  mixins: [formsMixin, accountApiMixin, MFormMixin],
  props: ["id"],
  data() {
    return {
      baseUrl: "imprests/imprestSettlement",
      appendSlash: true,
      rowKey: "account",
      hasList: false,
      hasIdProp: true,
      imprests: [],
      imprest: {},
      settleableAmount: null,
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('تسویه تنخواه')
    },
    imprestSum() {
      if (this.imprest && this.imprest.sanad) return this.imprest.sanad.bed;
      return 0;
    },
    // createUrl() {
    //   return "imprests/imprestSettlement/";
    // },
    // retrieveUrl() {
    //   return `transactions/${this.id}/`;
    // },
    // updateUrl() {
    //   return `imprests/imprestSettlement/${this.item.id}/`;
    // },
  },
  methods: {
    rowFactorSum(row) {
      let total = 0
      if (row.value){ total += +row.value}
      if (row.tax){ total += +row.tax}
      return total
    },
    rowSum(row) {
      let total = 0
      if (row.value){ total += row.value}
      if (row.tax){ total += row.tax}
      if (row.wage){ total += row.wage}
      return total
    },
    getSettleableAmount() {
      this.settleableAmount = 1000;
    },
    getItemTemplate() {
      return {
        items: [],
      };
    },
    getRowTemplate() {
      return {
        account: null,
      };
    },
    clearForm() {
      this.item = {};
      this.rows = [this.getRowTemplate()];
      if (this.id) {
        this.$router.push({
          name: "ImprestSettlementForm",
        });
      }
    },
    setItem(item) {
      this.changeRouteTo(item.id);

      if (!item) {
        item = this.getItemTemplate();
      }

      this.item = item;

      this.itemsToDelete = [];
      this.rows = [];
      item.items
        .sort((a, b) => a.order - b.order)
        .forEach((item) => {
          let row = { ...item };
          this.rows.push(row);
        });
      this.rows.push(this.getRowTemplate());
    },
    deleteRow(index) {
      if (index == -1) {
        this.rows.forEach((row) => {
          if (row.id) this.itemsToDelete.push(row.id);
        });
        this.rows.splice(0, this.rows.length - 1);
      } else {
        let row = this.rows[index];
        if (row.id) this.itemsToDelete.push(row.id);
        this.rows.splice(index, 1);
      }
    },
    getSerialized() {
      let data = {
        item: this.extractIds(this.item),
        items: {
          ids_to_delete: this.itemsToDelete,
          items: [],
        },
      };

      this.rows.forEach((row, i) => {
        if (i == this.rows.length - 1) return;

        let item = this.copy(row);
        item = this.extractIds(item);
        this.removeAttachmentUrls(item);
        data.items.items.push(item);
      });

      return this.jsonToFormData(data);
    },
  },
};
</script>

<style scoped lang="scss"></style>
